import { render } from "./InspectionsView.vue?vue&type=template&id=d38dc6f0"
import script from "./InspectionsView.vue?vue&type=script&lang=js"
export * from "./InspectionsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__